import { modalConfig, userConfig } from "../../actionTypes";

const initialState = {
  userAuthToken: "",
  showRefreshModal: false,
};

const config = (state = initialState, action) => {
  switch (action.type) {
    case userConfig.USER_TOKEN:
      const { userAuthToken } = action.payload || {};
      return {
        ...state,
        userAuthToken,
      };

    case userConfig.RESET:
      return {
        initialState,
      };

    case modalConfig.OPEN_REFRESH_MODAL:
      return {
        ...state,
        showRefreshModal: true,
      };

    case modalConfig.CLOSE_REFRESH_MODAL:
      return {
        ...state,
        showRefreshModal: false,
      };

    default:
      return state;
  }
};

export default config;
